// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Karla', 'Karla Fallback'"},"className":"__className_70dcc5"};